import { SharedStateProvider, TransitionsOfCareContent } from "@metriport/shared-internal";
import { useNavigate } from "react-router-dom";
import { ossBaseUrlEmbedPage } from "../../../api/api";
import { useAppContext } from "../../contexts/app/index";

export default function TcmPage() {
  const { state } = useAppContext();
  const navigate = useNavigate();

  if (!state.isLoaded) {
    return null;
  }

  function handleNavigateToPatient(patientId: string) {
    navigate(`/embed/app/patient/${patientId}`);
  }

  return (
    <SharedStateProvider
      authToken={state.authToken}
      baseUrl={ossBaseUrlEmbedPage}
      ehrDetails={undefined}
      featureFlags={state.featureFlags}
    >
      <TransitionsOfCareContent onNavigateToPatient={handleNavigateToPatient} />
    </SharedStateProvider>
  );
}
